/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { QuestionResultInvolvementSaveRequest } from "../model"
// @ts-ignore
import type { Result } from "../model"
/**
 * ResultResourceApi - axios parameter creator
 */
export const ResultResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get involvement check results by note id
     * @param {string} noteId
     * @param {boolean} [forceV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResult: async (
      noteId: string,
      forceV2?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getResult", "noteId", noteId)
      const localVarPath = `/involvement_check/results/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (forceV2 !== undefined) {
        localVarQueryParameter["forceV2"] = forceV2
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Save an answer to an involvement check question
     * @param {string} noteId
     * @param {QuestionResultInvolvementSaveRequest} questionResultInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveQuestionResult: async (
      noteId: string,
      questionResultInvolvementSaveRequest: QuestionResultInvolvementSaveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("saveQuestionResult", "noteId", noteId)
      // verify required parameter 'questionResultInvolvementSaveRequest' is not null or undefined
      assertParamExists(
        "saveQuestionResult",
        "questionResultInvolvementSaveRequest",
        questionResultInvolvementSaveRequest
      )
      const localVarPath = `/involvement_check/results/{noteId}/questions`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        questionResultInvolvementSaveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ResultResourceApi - functional programming interface
 */
export const ResultResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ResultResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get involvement check results by note id
     * @param {string} noteId
     * @param {boolean} [forceV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResult(
      noteId: string,
      forceV2?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResult(noteId, forceV2, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ResultResourceApi.getResult"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Save an answer to an involvement check question
     * @param {string} noteId
     * @param {QuestionResultInvolvementSaveRequest} questionResultInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveQuestionResult(
      noteId: string,
      questionResultInvolvementSaveRequest: QuestionResultInvolvementSaveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveQuestionResult(
        noteId,
        questionResultInvolvementSaveRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ResultResourceApi.saveQuestionResult"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ResultResourceApi - factory interface
 */
export const ResultResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ResultResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get involvement check results by note id
     * @param {ResultResourceApiGetResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResult(
      requestParameters: ResultResourceApiGetResultRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Result> {
      return localVarFp
        .getResult(requestParameters.noteId, requestParameters.forceV2, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Save an answer to an involvement check question
     * @param {ResultResourceApiSaveQuestionResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveQuestionResult(
      requestParameters: ResultResourceApiSaveQuestionResultRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Result> {
      return localVarFp
        .saveQuestionResult(
          requestParameters.noteId,
          requestParameters.questionResultInvolvementSaveRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getResult operation in ResultResourceApi.
 */
export interface ResultResourceApiGetResultRequest {
  readonly noteId: string

  readonly forceV2?: boolean
}

/**
 * Request parameters for saveQuestionResult operation in ResultResourceApi.
 */
export interface ResultResourceApiSaveQuestionResultRequest {
  readonly noteId: string

  readonly questionResultInvolvementSaveRequest: QuestionResultInvolvementSaveRequest
}

/**
 * ResultResourceApi - object-oriented interface
 */
export class ResultResourceApi extends BaseAPI {
  /**
   *
   * @summary Get involvement check results by note id
   * @param {ResultResourceApiGetResultRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getResult(
    requestParameters: ResultResourceApiGetResultRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ResultResourceApiFp(this.configuration)
      .getResult(requestParameters.noteId, requestParameters.forceV2, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Save an answer to an involvement check question
   * @param {ResultResourceApiSaveQuestionResultRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saveQuestionResult(
    requestParameters: ResultResourceApiSaveQuestionResultRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ResultResourceApiFp(this.configuration)
      .saveQuestionResult(
        requestParameters.noteId,
        requestParameters.questionResultInvolvementSaveRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
